import React from 'react';
import styled, { keyframes } from 'styled-components';
import closeIcon from '../../asset/img/common/close_icon2.svg';
import speaker from '../../asset/img/common/speaker_icon.svg';
import Button from '../../components/common/Button';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1002;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const DialogContainer = styled.div`
  background-color: white;
  border-radius: 16px;
  width: calc(100% - 32px);
  max-width: 360px;
  animation: ${fadeIn} 0.2s ease-out;
  z-index: 1003;
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.25);

  padding: 16px 16px 48px 16px;
`;

const Title = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 16px;
`;

const CloseIcon = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const InfoBox = styled.div`
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
`;

const InfoBoxTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  margin-bottom: 12px;
  color: #333;
`;

const InfoList = styled.ul`
  margin: 0;
  padding-left: 20px;
`;

const InfoItem = styled.li`
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  color: #555;
  list-style: disc !important;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
`;

const ReviewInProgressAlert = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <Overlay onClick={onClose}>
      <DialogContainer onClick={e => e.stopPropagation()}>
        <CloseIcon onClick={onClose}>
          <img src={closeIcon} alt="닫기" />
        </CloseIcon>
        <Title>
          <div className="displayFlex" style={{ gap: '8px', justifyContent: 'flex-start' }}>
            <img style={{ width: '24px' }} src={speaker} alt="검토 진행 중" />
            <div className="subtitleBold">연말정산 검토가 진행 중입니다</div>
          </div>
          <div
            className="body2Medium"
            style={{ whiteSpace: 'pre-wrap', textAlign: 'left', padding: '0 16px' }}>
            서류 작성 기간이 종료되어 현재 제출하신 내용을 검토하고 있습니다.
          </div>
        </Title>
        <InfoBox>
          <InfoBoxTitle>검토 기간 중 안내사항</InfoBoxTitle>
          <InfoList>
            <InfoItem>제출하신 내용은 조회 가능하나, 입력·수정·삭제는 불가합니다.</InfoItem>
            <InfoItem>
              검토 기간 중에는 상담 문의가 불가합니다. 상담이 필요하시면 AI 채팅 상담을 이용해
              주세요.
            </InfoItem>
            <InfoItem>검토가 완료되면 최종 환급/징수 결과를 확인하실 수 있습니다.</InfoItem>
            <InfoItem>
              제출하신 내용의 직접 수정은 불가합니다. 수정이 필요하신 경우 검토 완료 후 [제출 및
              결과조회 - 추가서류 제출함]에 요청해 주세요. 담당자 확인 후 처리해 드립니다.
            </InfoItem>
            <InfoItem>검토 일정은 홈화면 [연말정산 일정] 버튼을 통해 확인할 수 있습니다.</InfoItem>
          </InfoList>
        </InfoBox>
        <ButtonContainer>
          <Button value="확인" onClick={onClose} fullWidth />
        </ButtonContainer>
      </DialogContainer>
    </Overlay>
  );
};

export default ReviewInProgressAlert;
